import { Theme } from '@mui/material';
import { sidebarBreakpoint } from '~/variables/breakpoints';

const appStyle = {
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRows: 'auto 1fr',
    gridTemplateAreas: `
      "sidebar header"
      "sidebar main"
    `,
    height: '100vh',
    overflow: 'auto',
    // overflow: 'hidden',
  },
  topNavbar: {
    gridArea: 'header',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    padding: '12px 0px 0px',
    position: 'sticky',
    top: 0,
    zIndex: 2000,
    backgroundColor: 'secondary.main',
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    top: '0',
    overflow: 'auto',
    '&:after': {
      display: 'table',
      clear: 'both',
      content: '" "',
    },
  },
  map: {
    marginTop: '70px',
  },
  mainPanelSidebarMini: (theme: Theme) => ({
    [theme.breakpoints?.up('sm')]: {
      width: `calc(100% - ${theme.defaultStyles?.drawerWidthMini}px)`,
      [`@media (max-width: ${sidebarBreakpoint}px)`]: {
        width: '100%',
      },
    },
  }),
  mainPanelWithPerfectScrollbar: {
    overflow: 'hidden !important',
  },
  mainPanel: (theme: Theme) => ({
    gridArea: 'main',
    backgroundColor: theme.palette.secondary.main,
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    position: 'relative',
    float: 'right',
    transition: theme.defaultStyles?.transition,
    maxHeight: '100%',
    width: '100%',
    overflowY: 'auto',
    overflowScrolling: 'touch',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: '0',
  }),
} as const;

export default appStyle;
